"use client";

import { ArrowUpRight, MoveRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HydroRoof() {
  const {
    ref: leftRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="3815" id="fundamenty-naszej-pracy" className="relative dark bg-background text-foreground min-h-screen w-full overflow-hidden">
      <div className="flex flex-col lg:flex-row min-h-screen w-full">
        {}
        <div ref={leftRef} className="relative w-full lg:w-[45%] flex flex-col justify-between px-6 sm:px-10 lg:px-14 pt-24 pb-12 lg:py-16 order-2 lg:order-1">
          {}
          <div className={`flex items-center gap-3 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-3"}`}>
            <span className="inline-block w-2 h-2 bg-primary" />
            <span className="font-mono text-[11px] sm:text-xs tracking-[0.25em] uppercase text-muted-foreground">
              § HR-01 / TECH
            </span>
          </div>

          {}
          <div className="flex-1 flex flex-col justify-center py-12 lg:py-0">
            <h1 className="font-default font-extrabold leading-[0.88] tracking-tight uppercase" style={{
            fontSize: "clamp(3.5rem, 11vw, 12rem)"
          }}>
              <span className={`block overflow-hidden`}>
                <span className={`block transition-transform duration-1000 ease-[cubic-bezier(0.22,1,0.36,1)] ${isVisible ? "translate-y-0" : "translate-y-full"}`} style={{
                transitionDelay: "200ms"
              }}><span className="!text-9xl">HYDRO</span></span>
              </span>
              <span className="block overflow-hidden">
                <span className="block transition-transform duration-1000 ease-[cubic-bezier(0.22,1,0.36,1)] translate-y-0 !text-7xl" style={{
                transitionDelay: "400ms"
              }}>
                  ROOF{" "}
                  <span className="text-primary" style={{
                  textShadow: "0 0 24px color-mix(in oklab, var(--primary) 60%, transparent)"
                }}>
                    /
                  </span>
                </span>
              </span>
              <span className="block overflow-hidden">
                <span className="block transition-transform duration-1000 ease-[cubic-bezier(0.22,1,0.36,1)] translate-y-0 !text-7xl" style={{
                transitionDelay: "600ms"
              }}>
                  SYSTEMS
                </span>
              </span>
            </h1>

            {}
            <p className={`mt-8 lg:mt-10 max-w-[380px] font-default text-lg sm:text-xl leading-relaxed text-muted-foreground transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: "900ms"
          }}>
              Profesjonalna hydroizolacja i renowacja dachów metodą natryskową. Trwałość, odporność na warunki atmosferyczne i bezspoinowa ochrona Twojego obiektu.
            </p>

            {}
            <div className={`mt-10 flex flex-col sm:flex-row sm:items-center gap-5 sm:gap-8 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: "1100ms"
          }}>
              <Button asChild size="lg" className="group h-14 px-7 bg-primary text-primary-foreground hover:bg-primary/90 font-default font-bold tracking-[0.15em] uppercase text-xs shadow-2xl">
                <Link to="/OurSolutionsPage">
                  Bezpłatna wycena
                  <MoveRight className="ml-2 size-4 transition-transform duration-300 group-hover:translate-x-1.5" />
                </Link>
              </Button>

              <Link to="/ContactPage" className="group inline-flex items-center gap-2 font-mono text-xs tracking-[0.2em] uppercase text-foreground hover:text-primary transition-colors duration-300">
                <span className="border-b border-foreground/40 group-hover:border-primary pb-1">
                  Skontaktuj się
                </span>
                <ArrowUpRight className="size-3.5 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </Link>
            </div>
          </div>

          {}
          <div className="hidden lg:flex absolute bottom-12 left-6 items-center gap-4">
            <div className="flex items-center gap-3 [writing-mode:vertical-rl] rotate-180">
              <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-muted-foreground">
                SCROLL // HYDRO-TECH
              </span>
            </div>
            <div className="relative h-24 w-px bg-border overflow-hidden">
              <span className="absolute top-0 left-0 w-px h-8 bg-primary animate-[scrollLine_2.5s_ease-in-out_infinite]" />
            </div>
          </div>
        </div>

        {}
        <div className="relative w-full lg:w-[55%] h-[50vh] lg:h-auto lg:min-h-screen order-1 lg:order-2 overflow-hidden">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/hydro_roof_spray_application.png" alt="Profesjonalna aplikacja membrany natryskowej na dachu przemysłowym" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover animate-[kenBurns_20s_ease-out_infinite] contrast-125" />

          {}
          <div className="absolute inset-0 pointer-events-none opacity-[0.08] mix-blend-overlay" style={{
          backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")"
        }} />

          {}
          <div className="absolute inset-0 pointer-events-none" style={{
          background: "radial-gradient(ellipse at center, transparent 40%, color-mix(in oklab, var(--background) 70%, transparent) 100%)"
        }} />

          {}
          <div className="absolute inset-x-0 bottom-0 h-24 lg:hidden pointer-events-none" style={{
          background: "linear-gradient(to bottom, transparent, var(--background))"
        }} />

          {}
          <div className={`absolute bottom-6 right-6 lg:bottom-10 lg:right-10 backdrop-blur-md bg-background/30 border border-foreground/15 px-4 py-3 shadow-2xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: "1300ms"
        }}>
            <div className="flex items-center gap-3">
              <span className="inline-block w-1.5 h-1.5 bg-primary animate-pulse" />
              <div className="flex flex-col">
                <span className="font-mono text-[9px] tracking-[0.25em] uppercase text-muted-foreground">
                  Status
                </span>
                <span className="font-mono text-[11px] tracking-[0.15em] uppercase text-foreground">
                  Certyfikowana Ochrona
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes kenBurns {
          0% { transform: scale(1.0) translate(0, 0); }
          50% { transform: scale(1.12) translate(-1%, -1%); }
          100% { transform: scale(1.0) translate(0, 0); }
        }
        @keyframes scrollLine {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(400%); }
        }
      `}</style>
    </section>;
}